import React, { CSSProperties } from "react";

// External
import { GridRowParams } from "@mui/x-data-grid-pro";
import type { GridColumns, GridRowModel, GridSortItem, DataGridProProps } from "@mui/x-data-grid-pro";

// Hooks
import { UseNavigation } from "hooks/useNavigation";
// Components
import { FiltersT } from "components/Pagination/SearchFilterPagination/NewFilters/types";
import { OrgProjectsCsvT } from "rdx/modules/csvReports/types";
import BasicTable from "../BasicTable";

// Link to learn more about the generic types: {https://www.typescriptlang.org/docs/handbook/2/generics.html}
type ProjectsTablePropsT<TData extends GridRowModel> = {
  rows: TData[];
  columns: GridColumns;
  sortItems?: FiltersT;
  getCsv?: (search: Record<string, unknown>) => void;
  getCsvReport?: ({ reportId }: { reportId: number }) => void;
  selectedCsv?: Record<string, number | string> | OrgProjectsCsvT;
  navigate?: ReturnType<UseNavigation>["navigate"];
  override?: ReturnType<UseNavigation>["override"];
  totalResultCount?: number;
  addLead?: boolean;
  isLoading?: boolean;
  getData?: (payload?: Record<string, unknown>) => void;
  resetData?: () => void;
  onRowClick?: (params: GridRowParams) => void;
  defaultSort?: GridSortItem;
  rightSideComponent?: React.ReactElement;
  isMobile?: boolean; // after all tables have the same design could be removed
  hideFilterBar?: boolean;
  hideColumnHeaders?: boolean;
  hideBottomPadding?: boolean;
  noXScroll?: boolean;
  containerStyles?: CSSProperties;
  hideCSV?: boolean;
  isRefetchingTableData?: boolean;
  showTeamViewButton?: boolean;
} & DataGridProProps;

const ProjectsTable = <T extends Record<string, unknown>>({
  rows,
  columns,
  getCsv,
  getCsvReport,
  selectedCsv,
  sortItems,
  navigate,
  override,
  totalResultCount,
  addLead,
  isLoading,
  getData,
  resetData,
  onRowClick,
  defaultSort,
  rightSideComponent,
  isMobile,
  hideFilterBar = false,
  hideColumnHeaders = false,
  hideBottomPadding = false,
  containerStyles = {},
  noXScroll = false,
  hideCSV = false,
  isRefetchingTableData = false,
  showTeamViewButton = false,
}: ProjectsTablePropsT<T>) => {
  return (
    <BasicTable<T>
      rows={rows}
      columns={columns}
      getCsv={getCsv}
      getCsvReport={getCsvReport}
      selectedCsv={selectedCsv}
      sortItems={sortItems}
      navigate={navigate}
      override={override}
      totalResultCount={totalResultCount}
      isLoading={isLoading}
      getData={getData}
      resetData={resetData}
      onRowClick={onRowClick}
      defaultSort={defaultSort}
      rightSideComponent={rightSideComponent}
      isMobile={isMobile}
      showFilterBarButton={addLead}
      hideFilterBar={hideFilterBar}
      hideColumnHeaders={hideColumnHeaders}
      hideBottomPadding={hideBottomPadding}
      containerStyles={{ ...containerStyles, paddingLeft: "0px" }}
      rowHeight={75}
      noXScroll={noXScroll}
      hideCSV={hideCSV}
      isRefetchingTableData={isRefetchingTableData}
      showTeamViewButton={showTeamViewButton}
    />
  );
};

export default ProjectsTable;
